import React from 'react';
import { Switch } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import fundebug from 'fundebug-javascript';
import 'fundebug-revideo';

import config from '@/config';

import AiBookHomePage from './home';

import zhCN from 'antd/lib/locale/zh_CN';
// 先引入antd样式，再引项目样式
import 'antd/lib/style';

import { addEventListenerCreativeMessage } from '@/utils/creativeTaskUtils';

import './App.scss';
import NetworkListener from './components/NetworkListener/NetworkListener';

fundebug.init({
  apikey: '75c3fc39275adb6cb2fcd1d81d1bdfafd19f617b81be0f4154492e75b76d8e77'
});

export default class App extends React.PureComponent {

  componentDidMount() {
    // 区分mac和windows
    const ismac = /macintosh|mac os x/i.test(navigator.userAgent);
    if(ismac) {
      document.body.setAttribute('ismac', '1');
    }
    
    addEventListenerCreativeMessage();
  }

  componentDidCatch(error, info) {
    console.error(error, info);
    // 将component中的报错发送到Fundebug
    config.env !== 'TEST' && fundebug.notifyError(error, {
      metaData: {
        info: info
      }
    });
  }

  render() {

    return (
      <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
        {
          this.props.children ? <Switch>
            {this.props.children}
          </Switch> : <AiBookHomePage />
        }
        <NetworkListener />
      </ConfigProvider>
    );
  }
}
